import GrayCard from "components/gray-card";
import DateInput from "components/inputs/date-input";
import Radio from "components/radio";
import Typography from "components/typography";
import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "utils/colors";

interface IProps {
  date: Date | null;
  setDate: (date: Date | null) => void;
}
const OGReleaseDate = ({ date, setDate }: IProps) => {
  const [radio, setRadio] = useState("no");
  return (
    <GrayCard title="Original Release Date">
      <Typography mb="1.5" color={Colors.grey400} weight="medium">
        Has this release been released before?
      </Typography>
      <RadioContainer>
        <RadioItem>
          <Radio
            value={radio === "yes"}
            onClick={() => {
              setRadio("yes");
            }}
          />
          <Typography ml="0.4">Yes</Typography>
        </RadioItem>
        <RadioItem>
          <Radio
            value={radio === "no"}
            onClick={() => {
              setRadio("no");
            }}
          />
          <Typography ml="0.4">No</Typography>
        </RadioItem>
      </RadioContainer>
      {radio === "yes" ? (
        <DateItem>
          <DateInput
            label="Select original release date"
            maxDate={new Date()}
            selectDate={(date) => setDate(date)}
            initialDate={date}
          />
        </DateItem>
      ) : null}
    </GrayCard>
  );
};

export default OGReleaseDate;

const RadioContainer = styled.div`
  width: 30%;
  display: grid;
  grid-template-columns: 50% 50%;
  align-items: center;
  justify-content: space-between;
`;

const RadioItem = styled.div`
  display: flex;
  align-items: center;
`;

const DateItem = styled.div`
  margin-top: 2.4rem;
`;
